exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3Mb8DcaL4EnqWk{padding-top:12px;font-family:Helvetica Neue,Arial,Helvetica,sans-serif;font-size:12px;line-height:20px}._3Mb8DcaL4EnqWk a{color:#172b4d}", ""]);

// exports
exports.locals = {
	"whiteBox": "_3Mb8DcaL4EnqWk"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"importLoaders":2,"localIdentName":"[hash:base64:14]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-3053/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/common/components/create-board/private-board-info.less
// module id = notK
// module chunks = 24